module.exports = __webpack_public_path__ + "a1927ba883e40d7782e8fe6db3bd18d7.pdf";